import * as stylex from "@stylexjs/stylex";
import { ChevronLeft, type LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import "@/theme/tokens.stylex";
import { colors } from "@/theme/tokens.stylex";
import { IconButton } from "./IconButton";
type PageTopBarProps = {
  backLabel: string;
  backIcon?: LucideIcon;
  backDisabled?: boolean;
  onBack?: () => void;
  title?: ReactNode;
  compact?: boolean;
  children?: ReactNode;
};
export function PageTopBar({
  backLabel,
  backIcon = ChevronLeft,
  backDisabled,
  onBack,
  title,
  compact,
  children
}: PageTopBarProps) {
  return <div data-page-top-bar {...{
    0: {
      className: "x7wzq59 x13vifvy x1355qak x2lah0s xeuugli xefclja x9f619 x78zum5 x1a02dak x6s0dn4 x6d3xby x10dr8xq x1174a9 x5r8ks9 xso031l x1q0q8m5 xja0v4t x1a11ngh"
    },
    1: {
      className: "x7wzq59 x13vifvy x1355qak x2lah0s xeuugli x9f619 x78zum5 x1a02dak x6s0dn4 x5r8ks9 xso031l x1q0q8m5 xja0v4t x1a11ngh xbktkl8 x167g77z x1vvogim xaope02"
    }
  }[!!compact << 0]}>
      {onBack && <IconButton icon={backIcon} label={backLabel} variant="canvas" size={compact ? "md" : "touch"} disabled={backDisabled} onClick={onBack} />}
      {title && <span {...{
      0: {
        className: "xeuugli xack27t xzlubvl xfbjfs5 xrg9stw x1159mfc xuxw1ft"
      },
      1: {
        className: "xeuugli xack27t xfbjfs5 xrg9stw x1159mfc xuxw1ft xwsyq91"
      }
    }[!!compact << 0]}>{title}</span>}
      {children}
    </div>;
}